import axios from 'axios';

import store from 'state/store/store';
import { signOut } from 'state/actions/auth_status';
import { changePage, updatePageDetails } from '@insticator/insticator-ui';
import { getUserPermissions } from 'state/actions/auth_status';

const handleErrorResponse = (response) => {
    switch(response.status) {
        case 401:
            handleError401();
            return;
        case 403:
            handleError403();
            return;
        default:
            return;
    }
};

// if the user is not authenticated, they are automatically signed out and returned to sign in screen.
// If the user is already on signin page, stop calling the dispatch in loop.
const handleError401 = () => {
    if((window.location.href.indexOf("auth") === -1)) store.dispatch(signOut());
};

// Returned to 403 error page if user is not permitted to perform certain actions.
const handleError403 = () => {
    // store.dispatch(updatePageDetails('error/403/'));
    // store.dispatch(changePage('error/403/true'));
    store.dispatch(getUserPermissions(store.getState().sessionStatus.userUUID));
};

// The response interceptors listen to all the responses coming in from the server.
// Here we check the error status and take appropriate action.
axios.interceptors.response.use(function(response) { return response; }, function(error) {
    if(!!error.response) {
        handleErrorResponse(error.response);
    }
    return Promise.reject(error);
});
